import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();


    //use refs to handle own state for each instance of withRouter hoc
    const navigateRef = useRef(navigate);
    const readyRef = useRef(false);
    const queueRef = useRef([]);

    //handle always fresh navigate
    useLayoutEffect(() => {
      navigateRef.current = navigate;
    });

    //this executes when WithRouter is subscribed for history, so run all queue and then work as usual (without queue)
    useEffect(() => {
      readyRef.current = true;
      const queue = queueRef.current;
      queueRef.current = [];
      queue.forEach((args) => navigateRef.current(...args));
    }, []);

    const safeNavigate = useCallback((...args) => {
      if (!readyRef.current) {
        queueRef.current.push(args); //was called too late, earlier than WithRouter subscribe for history (componentDidMount, constructor etc)
        return;
      }
      return navigateRef.current(...args);
    }, []);

    return (
      <Component
        {...props}
        router={{ location, navigate: safeNavigate, params }}
      />
    );
  }
  return ComponentWithRouterProp;
}

export default withRouter;